import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  inset: 0;
  background: color-mix(in srgb, var(--brand-navy, #00212d) 52%, transparent);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
`;

export const ModalBox = styled.div`
  position: relative;
  border-radius: 18px;
  padding: 1.5rem;
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-lg);
  color: var(--text-primary);
  overflow-x: hidden;
  overflow-y: auto;
  max-width: min(100%, 640px);
  width: 100%;
  max-height: min(90vh, 820px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--brand-cta-gradient-135);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  background: var(--surface-3);
  border: none;
  color: var(--text-secondary);
  font-size: 1.25rem;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: 1;
  transition: all 0.2s ease;

  &:hover {
    background: var(--surface-hover);
    color: var(--text-heading);
  }
`;
